import { createIcon } from "@chakra-ui/react";

const Neutral = createIcon({
  displayName: "Neutral",
  viewBox: "24 24 40 40",
  path: (
    <>
      <circle cx="44" cy="44" r="20" fill="currentColor" />
      <circle cx="52.22" cy="40.65" r="2.08" />
      <circle cx="35.78" cy="40.65" r="2.08" />
      <path d="M53 51.34H35a1 1 0 0 1 0-1.92h18a1 1 0 0 1 0 1.92z" />
    </>
  )
});

export default Neutral;
